import { VStack } from '@chakra-ui/react'
import { Global, css } from '@emotion/react'

import PageHeader from '@/features/OurProducts/components/atoms/PageHeader'
import ContactForm from '@/features/OurProducts/components/atoms/ContactForm'
import Product from '@/features/OurProducts/components/molecules/Product'

import { PRODUCTS } from '@/features/OurProducts/constants'

const GlobalStyles = css`
  :root {
    scroll-behavior: unset;
  }
`

function OurProducts(): React.ReactElement {
  return (
    <VStack
      spacing="0"
      sx={{
        mt: '56px',
        w: '100%',
        alignItems: 'stretch',
      }}
    >
      <Global styles={GlobalStyles} />
      <PageHeader products={PRODUCTS} />
      {PRODUCTS.map((product, index) => {
        return <Product key={product.id} index={index} {...product} />
      })}
      <ContactForm />
    </VStack>
  )
}

OurProducts.propTypes = {}

OurProducts.defaultProps = {}

export default OurProducts
